(function () {
  'use strict';
  var el = document.getElementById('lisStickyCta');
  if (!el) return;
  var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 50;
  var breakpoint = parseInt(el.getAttribute('data-breakpoint'), 10) || 768;
  var isVisible = false, ticking = false, enabled = false;
  function isMobile() { return window.innerWidth <= breakpoint; }
  function show() { if (isVisible) return; isVisible = true; el.classList.add('is-visible'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('lis-sticky-active'); }
  function hide() { if (!isVisible) return; isVisible = false; el.classList.remove('is-visible'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lis-sticky-active'); }
  function update() {
    ticking = false; if (!enabled) return;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) { hide(); return; }
    if ((scrollTop / scrollable) * 100 >= threshold) { show(); } else { hide(); }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  function handleResize() {
    if (isMobile()) { if (!enabled) { enabled = true; window.addEventListener('scroll', onScroll, { passive: true }); update(); } }
    else { if (enabled) { enabled = false; window.removeEventListener('scroll', onScroll); hide(); } }
  }
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(handleResize, 100); }, { passive: true });
  handleResize();
})();
